// /* eslint no-console: 0 */
import Vue from 'vue'
import focus from '../directives/focus'
import helpers from "../globals/helpers";
import VueUnits from 'vue-units';

// import store
import store from "../store";

// import custom components
const AutarkyChart = () => import('../vue/autarky-chart.vue');
const AlarmsChart = () => import('../vue/alarms-chart.vue');
const PowerChart = () => import('../vue/power-chart.vue');
const PowerMapChart = () => import('../vue/power-map-chart.vue');
const DataExport = () => import('../vue/data-export.vue');
const EnergyReportChart = () => import('../vue/energy-report-chart.vue');
const ProductionAndConsumptionChart = () => import('../vue/production-and-consumption-chart.vue');
const EnergyAggregates = () => import('../vue/energy-aggregates.vue');
const SiteSchemaEditor = () => import('../vue/site-schema-editor/site-schema-editor.vue');
const ThingEvents = () => import(/* webpackChunkName: "site-schema-editor" */  '../vue/thing-events.vue');
const SiteConfigurationTool = () => import('../vue/site-configuration-tool/SiteConfigurationTool.vue')
const AlarmOverview = () => import('../vue/alarm-overview.vue')
const DeviceOverview = () => import('../vue/device-overview.vue')
const BatteryControls = () => import('../vue/battery-controls/battery-controls.vue')
const MeterReadings = () => import('../vue/meter_readings.vue')
const DateRangePicker = () => import('../vue/date-range-picker.vue')

// register components to use
Vue.component('autarky-chart', AutarkyChart)
Vue.component('alarms-chart', AlarmsChart)
Vue.component('power-chart', PowerChart)
Vue.component('power-map-chart', PowerMapChart)
Vue.component('data-export', DataExport)
Vue.component('energy-report-chart', EnergyReportChart)
Vue.component('production-and-consumption-chart', ProductionAndConsumptionChart)
Vue.component('energy-aggregates', EnergyAggregates)
Vue.component('site-schema-editor', SiteSchemaEditor)
Vue.component('thing-events', ThingEvents)
Vue.component('site-configuration-tool', SiteConfigurationTool)
Vue.component('alarm-overview', AlarmOverview)
Vue.component('device-overview', DeviceOverview)
Vue.component('battery-controls', BatteryControls)
Vue.component('meter-readings', MeterReadings)
Vue.component('date-range-picker', DateRangePicker)

// add directives
Vue.directive('focus', focus)

Vue.use(VueUnits)

// add global mixins
Vue.mixin({
    methods: {
        t: (scope, options = {}) => helpers.t(scope, options),
        lv: (enValue, deValue) => helpers.localizedValue(enValue, deValue),
        hideTooltips() {
            const shownTooltip = document.querySelector(".tooltip");
            if(shownTooltip != null) {
                shownTooltip.remove();
            }
        }
    },
    beforeUpdate() {
        this.hideTooltips()
    }
})

document.addEventListener('turbo:load', () => {
    document.querySelectorAll('[data-behaviour="vue"]').forEach(el => {
        new Vue({ el, store })
    })
})
